module.exports = __webpack_public_path__ + "people_after.9b2156b7.png";